import $axios from '@/api/apiPublic';

const getManuals = async service => {
  const response = await $axios.get(`articles/service?service=${service}`);
  return response;
};

const getVideos = async () => {
  const response = await $axios.get('articles/video-lessons');
  return response;
};

export default {
  getManuals,
  getVideos,
};
